import React, { useEffect, useState } from 'react';
import { getRecords, getExercises } from '../api';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const PERIODS = [
  { label: '1ヶ月', days: 30 },
  { label: '3ヶ月', days: 90 },
  { label: '6ヶ月', days: 180 },
  { label: '全期間', days: null },
];

const GraphPage = () => {
  const [exercises, setExercises] = useState([]);
  const [selectedExercise, setSelectedExercise] = useState('');
  const [period, setPeriod] = useState(90);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getExercises().then((res) => {
      setExercises(res.data);
      if (res.data.length > 0) setSelectedExercise(res.data[0].name);
    });
  }, []);

  useEffect(() => {
    if (!selectedExercise) return;
    setLoading(true);
    getRecords({ exercise: selectedExercise })
      .then((res) => {
        const now = new Date();
        const filtered = res.data.filter((r) => {
          if (!period) return true;
          const diff = (now - new Date(r.date)) / (1000 * 60 * 60 * 24);
          return diff <= period;
        });

        // 日付ごとに最大重量とボリュームを集計
        const grouped = filtered.reduce((acc, r) => {
          if (!acc[r.date]) acc[r.date] = { date: r.date, maxWeight: 0, volume: 0 };
          acc[r.date].maxWeight = Math.max(acc[r.date].maxWeight, r.weight);
          acc[r.date].volume += r.weight * r.reps;
          return acc;
        }, {});

        setChartData(Object.values(grouped).sort((a, b) => a.date.localeCompare(b.date)));
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [selectedExercise, period]);

  return (
    <div className="page">
      <h1>グラフ</h1>

      <div className="graph-controls">
        <select
          value={selectedExercise}
          onChange={(e) => setSelectedExercise(e.target.value)}
        >
          {exercises.map((e) => (
            <option key={e.name} value={e.name}>{e.name}</option>
          ))}
        </select>

        <div className="period-buttons">
          {PERIODS.map((p) => (
            <button
              key={p.label}
              className={period === p.days ? 'active' : ''}
              onClick={() => setPeriod(p.days)}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="loading">読み込み中...</div>
      ) : chartData.length === 0 ? (
        <p>データがありません</p>
      ) : (
        <>
          <h2>最大重量の推移 (kg)</h2>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="maxWeight" name="最大重量(kg)" stroke="#2563eb" strokeWidth={2} dot={true} />
            </LineChart>
          </ResponsiveContainer>

          <h2>ボリュームの推移 (kg×回)</h2>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="volume" name="ボリューム(kg×回)" stroke="#16a34a" strokeWidth={2} dot={true} />
            </LineChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default GraphPage;